<template>
  <div class="feature-landing-page">
    <!-- prettier-ignore -->

    <ApiLoading v-if="apiStatus.refData.loading && apiStatus.membershipInfo.loading" :apiError="apiStatus.membershipInfo.fail" isMemberPortal />
    <ApiLoading v-else-if="apiStatus.membershipInfo.fail && apiStatus.refData.fail" :apiError="apiStatus.membershipInfo.fail" isMemberPortal />
    <section v-else class="top-content mp-section">
      <ApiLoading v-if="apiStatus.refData.fail || apiStatus.refData.loading" :apiError="apiStatus.refData.fail" isMemberPortal />
      <div v-else class="left">
        <h2 class="h4 home-section-title">Quick links</h2>
        <p>
          With our recent updates you can now
          <!-- prettier-ignore -->
          <a :href="getTaskLink('~/portal/$memberNumber$/my-cover/payments/make-a-payment')">make immediate payments</a>
          and update your payment details.
          <br />
          <br />
          Soon you’ll be able to adjust your rebate and excess.
        </p>
        <div id="top-tasks" class="flex-wrap-section">
          <template v-for="task in filterTasks" :key="task.title">
            <TaskButton :imageSrc="getImageUrl(task.imageUrl)" :imageAlt="task.imageAltText" :href="getTaskLink(task.toUrl)" :hasArrow="true">
              {{ task.title }}
            </TaskButton>
          </template>
        </div>
      </div>
      <div class="right">
        <ApiLoading v-if="apiStatus.membershipInfo.fail || apiStatus.membershipInfo.loading" :apiError="apiStatus.membershipInfo.fail" isMemberPortal />
        <div v-else>
          <h2 class="h4 home-section-title">Policy status</h2>
          <div class="policy-status" :class="{ 'self-access': !isFullAccess }">
            <div class="policy-status-field">
              <p>Member name </p>
              <p class="policy-info">{{ membershipDetails.memberFullName }}</p>
            </div>
            <div v-if="isFullAccess" class="policy-status-field">
              <p>Member status </p>
              <p class="policy-info">{{ toSentenceCase(membershipDetails.policyStatus) }}</p>
            </div>
            <div class="policy-status-field">
              <p>Membership covered until </p>
              <p v-if="membershipDetails.datePaidTo !== null" class="policy-info">{{ convertDateStringToText(membershipDetails.datePaidTo) }}</p>
              <p v-else class="policy-info">Your first premium has not been paid</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { PaymentFrequency } from '@general/js/enums';
import { getImageUrl, isEmptyString } from '@/utils';
import TaskButton from '@general/js/components/TaskButton.vue';
import { toSentenceCase, convertDateStringToText } from '@general/js/utils';
import ApiLoading from './ApiLoading.vue';

export default {
  name: 'TopTasks',

  components: {
    ApiLoading,
    TaskButton,
  },

  props: {
    // Top task tile
    topTasksOptions: {
      type: Array,
      required: true,
    },
    apiStatus: {
      type: Object,
      required: true,
    },
    membershipDetails: {
      type: Object,
    },
    isFullAccess: {
      type: Boolean,
    },
    currentIsExtrasFlag: {
      type: Boolean,
    },
    hasAccessToTaxPage: {
      type: Boolean,
    },
  },

  computed: {
    // Filtered task and only show accessible tasks
    filterTasks() {
      // Removed tasks that member don't have access to them
      let filteredTasks;

      // "Make a payment" link is not visible to self access users
      if (!this.isFullAccess) {
        // Hide access to payments page
        filteredTasks = this.topTasksOptions.filter((task) => {
          return !task.toUrl.toLowerCase().includes('/my-cover/payments');
        });
      }

      // Hide link of benefit quotes page when currentIsExtrasFlag is false
      if (!this.currentIsExtrasFlag === true) {
        let selfAccessFilterTasks = [...this.topTasksOptions];
        // Check if filteredTasks has been populated
        if (filteredTasks) selfAccessFilterTasks = [...filteredTasks];
        filteredTasks = selfAccessFilterTasks.filter((task) => {
          // Not have access to benefit quote page, make a claim page when no extras in policy
          const hiddenTaskUrls = ['/my-claims/benefit-quotes', 'my-claims/claims/make-a-claim'];
          return !hiddenTaskUrls.some((taskUrl) => {
            return task.toUrl.toLowerCase().includes(taskUrl);
          });
        });
      } else if (!filteredTasks) {
        filteredTasks = [...this.topTasksOptions];
      }

      // Tax Statements is only visible to Policy Holder and Full Access users
      if (!this.hasAccessToTaxPage) {
        return filteredTasks.filter((task) => {
          return !task.toUrl.toLowerCase().includes('/my-cover/tax-statements');
        });
      }

      return filteredTasks;
    },
  },

  methods: {
    mappingPaymentFrequency(frequency) {
      switch (frequency.toLowerCase()) {
        case PaymentFrequency.FORTNIGHTLY.toLowerCase():
          return 'fortnight';
        case PaymentFrequency.MONTHLY.toLowerCase():
          return 'month';
        case PaymentFrequency.QUARTERLY.toLowerCase():
          return 'quarter';
        case PaymentFrequency.SEMI_ANNUAL.toLowerCase():
          return '6 months';
        case PaymentFrequency.ANNUAL.toLowerCase():
          return 'year';
        default:
          return '';
      }
    },

    // Remove ~ from url and swap token
    getTaskLink(link) {
      return link.replace(/~/i, '').tokenSwap();
    },
    getImageUrl,
    convertDateStringToText,
    isEmptyString,
    toSentenceCase,
  },
};
</script>

<style lang="scss" scoped>
.policy-info {
  font-weight: $BOLD;
}

.policy-status-field {
  p:first-child {
    margin-bottom: 0.5rem;
  }
}
</style>
